import { HumanizerVisualization, HumanizerWarning } from '@ambire-common/libs/humanizer/interfaces'

// The clause only has room for tokens, one spender and a deadline. A message that says more (a
// recipient, a second address, a warning such as "anyone can choose where the tokens go") goes to
// the generic visualization, which shows every item and the warnings.
export const getApprovalClauseVisualization = (
  fullVisualization: HumanizerVisualization[] | undefined,
  warnings: HumanizerWarning[] | undefined
): HumanizerVisualization[] | null => {
  if (!fullVisualization?.some((i) => i?.type === 'token')) return null
  if (warnings?.length) return null
  if (fullVisualization.filter((i) => i?.type === 'address').length > 1) return null
  return fullVisualization
}
